import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import React from "react";
import type { StoredProcedure } from "../models/SPExecutorModels";

type Props = {
	procedures: StoredProcedure[];
	value: StoredProcedure | null;
	onChange: (value: StoredProcedure | null) => void;
	isLoading: boolean;
	disabled?: boolean;
};

export const SPAutocomplete = ({
	procedures,
	value,
	onChange,
	isLoading,
	disabled = false,
}: Props) => {
	return (
		<Autocomplete
			options={procedures}
			value={value}
			onChange={(_, newValue) => onChange(newValue)}
			getOptionLabel={(option) => option.FullName}
			groupBy={(option) => option.SchemaName}
			disabled={disabled}
			isOptionEqualToValue={(option, val) => option.FullName === val.FullName}
			renderInput={(params) => (
				<TextField
					{...params}
					label="Select Stored Procedure"
					variant="outlined"
					fullWidth
					slotProps={{
						input: {
							...params.InputProps,
							endAdornment: (
								<>
									{isLoading ? (
										<CircularProgress color="inherit" size={20} />
									) : (
										params.InputProps.endAdornment
									)}
								</>
							),
						},
					}}
				/>
			)}
			renderOption={(props, option) => (
				<li {...props} key={option.FullName}>
					{option.SchemaName}.{option.ProcedureName}
				</li>
			)}
		/>
	);
};
